import { Dispatch } from "redux";
import { createActionCreator, createReducer } from "deox";
import * as filtersService from "../services/filters";
import { Filter } from "../models/misc";

export type State = {
  data: Filter | null;
  all:  Filter[] | null;
};

const defaultState: State = {
  data: null,
  all:  null,
};

// fetch one
const fetchFilter = Object.assign(
  (filterId: number) => async (dispatch: Dispatch) => {
    try {
      const result = await filtersService.getFilter(filterId);
      dispatch(fetchFilter.success(result));
    } catch {}
  },
  {
    success: createActionCreator(
      "@@FILTERS/FETCH",
      resolve => (data: Filter) => resolve(data)
    )
  }
);

// fetch all
const fetchAllFilters = Object.assign(
  () => async (dispatch: Dispatch) => {
    try {
      const result = await filtersService.getAllFilters();
      dispatch(fetchAllFilters.success(result));
    } catch {}
  },
  {
    success: createActionCreator(
      "@@FILTERS/ALL_FETCH",
      resolve => (data: Filter[]) => resolve(data)
    )
  }
);

const createFilter = (filter: Partial<Filter>) => async (dispatch: any) => {
  try {
    await filtersService.createFilter(filter);
    dispatch(fetchAllFilters());
  } catch {}
};

const updateFilter = (filter: Filter) => async (dispatch: any) => {
  try {
    await filtersService.updateFilter(filter);
    dispatch(fetchAllFilters());
  } catch {}
};

const deleteFilter = (filterId: number) => async (dispatch: any) => {
  try {
    await filtersService.deleteFilter(filterId);
    dispatch(fetchAllFilters());
  } catch {}
};

const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchFilter.success, (state, action) => ({
    ...state,
    data: action.payload
  })),
  handleAction(fetchAllFilters.success, (state, action) => ({
    ...state,
    all: action.payload
  }))
]);

const actions = {
  fetchFilter,
  fetchAllFilters,
  createFilter,
  updateFilter,
  deleteFilter
};

export { actions, reducer };
